import { useState, useEffect } from 'react';

import AdminAllClientsModel from './AdminAllClientsModel';

export function useClients({ type, status, limit }) {
    const [clients, setClients] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const onUpdateClients = async (clientsList) => {
            setClients(clientsList);
            setLoading(false);
        };  

        const model = new AdminAllClientsModel({
            type: type || null,
            status: status || null, 
            limit: limit || null,
            onUpdate: onUpdateClients,
        });

        model.waitForClientsData();
        setLoading(true);

        return function cleanup() {
            model.stop();
            setLoading(false);
        };

    },
        [type, status, limit]
    );

    return [loading, clients];
}
